import { initializeApp } from 'firebase/app'
import { ref as dbRef, getDatabase, onValue } from 'firebase/database'

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyCRI5Mp-CHT7gF1UVRxFHFyB1xmiErsirc",
  authDomain: "workshop-config.firebaseapp.com",
  databaseURL: "https://cf-prod-viv0006-rukobia-nsm-qwl10-94ae68aa.firebaseio.com"
})

// used for the firestore refs
export const db = getDatabase(firebaseApp)

export const loginsRef = dbRef(db, 'logins');
export const usersRef = dbRef(db, 'users');
export const roundsRef = dbRef(db, 'rounds');
// export const passwordRef = dbRef(db, 'password');
// export const endTimeRef = dbRef(db, 'endTime');

// start listening to firebase connection after slight delay
  // alert users when they disconnect from the database, likely a result of connectivity issues at the venue
const connectionRef = dbRef(db, '.info/connected')

window.setTimeout(() => {
  onValue(connectionRef, (snapshot) => {
    if(snapshot.val() === true){
      if(window.quizWhizApp.showErrorModal){
        window.quizWhizApp.toggleErrorModal()
        window.quizWhizApp.updateErrorMessage('')
        window.quizWhizApp.toggleLoggedInStatus(true)
      }
    }else{
      window.quizWhizApp.updateErrorMessage('Connection lost.  Please connect to the network before continuing.')
      window.quizWhizApp.toggleErrorModal()
      window.quizWhizApp.toggleLoggedInStatus(false)
    }
  })
}, 5000)
